module.exports = __webpack_public_path__ + "img/logo_blanco.27ce9a20.svg";